import { perms } from '../../jcs';
import { dashboardModule } from './index';

function routeConfig($provide, $routeProvider) {
	'ngInject';

	$provide.factory('$routeProvider', () => {
		return $routeProvider;
	});

	$routeProvider.when(dashboardModule.routes.list, {
		controller: dashboardModule.controllers.default,
		template: require('./dashboard.tmpl.html').default,
		activenav: dashboardModule.name,
		access: {
			loginRequired: true,
			permissions: [perms['dashboard.get'], perms['dashboard.multisite.get']],
		},
	});
}

export default routeConfig;
